import { useIsEditorContext } from "@editor-providers";
import { useEffect, useState, type RefObject } from "react";
import { throttle } from "../utils";

export const useCurrentStepIndex = (contentRef: RefObject<HTMLDivElement>) => {
  const [currentSetIndex, setCurrentSetIndex] = useState<null | number>(0);
  const isEditor = useIsEditorContext();
  useEffect(() => {
    const topOffset = !isEditor ? 0 : 122;
    const wizardRoot = document.querySelector("#wizard-root");
    const scrollContainer = wizardRoot
      ? document.querySelector("[data-scroll-container]")
      : null;

    const scrollTarget = scrollContainer || window;

    const handleScroll = throttle(() => {
      if (!contentRef.current) return;
      const container = contentRef.current as HTMLElement;

      const visibleHeight = window.innerHeight - topOffset;
      const steps = container.querySelectorAll(
        ".combo-narrator__content__step",
      );
      let winner: { idx: number; dist: number } | null = null;
      steps.forEach((step) => {
        if (step instanceof HTMLElement) {
          const stepRect = step.getBoundingClientRect();
          const stepY = stepRect.y - (topOffset - stepRect.height / 2);
          const dist = Math.abs(visibleHeight / 2 - stepY);
          const idx = step.getAttribute("data-step-index");
          if (idx) {
            if (!winner || dist < winner.dist) {
              winner = {
                idx: Number(idx),
                dist: dist,
              };
            }
          }
        }
      });
      if (winner) {
        setCurrentSetIndex((winner as any).idx);
      }
    }, 100);

    scrollTarget.addEventListener("scroll", handleScroll);
    return () => {
      scrollTarget.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return currentSetIndex;
};
